import { render, staticRenderFns } from "./onePressReleases2.vue?vue&type=template&id=e1abec1c&scoped=true&"
import script from "./onePressReleases2.vue?vue&type=script&lang=js&"
export * from "./onePressReleases2.vue?vue&type=script&lang=js&"
import style0 from "./onePressReleases2.vue?vue&type=style&index=0&id=e1abec1c&lang=scss&scoped=true&"
import style1 from "./onePressReleases2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1abec1c",
  null
  
)

export default component.exports